import { Link } from 'react-router-dom'

import { changelog, newsCopy } from '../content/changelog'
import { PAGES, type Lang } from '../i18n'
import styles from './NewsPage.module.css'

/**
 * The changelog from content/changelog.json, in the language of the URL.
 *
 * App entries with version === null have not shipped yet; they are labelled rather than
 * hidden, so the page is honest about what a tester has today versus what is on its way.
 * Web entries carry no version pill at all: the site deploys on merge, so it is always the
 * current one. Same reading column as the contact and legal pages.
 */
export default function NewsPage({ lang }: { lang: Lang }) {
  const t = newsCopy[lang]

  return (
    <article className={`container--reading ${styles.article}`}>
      <Link to={PAGES.home[lang]} className={styles.back}>
        {t.back}
      </Link>

      <h1 className={styles.title}>{t.title}</h1>
      <p className={styles.lede}>{t.lead}</p>

      <ol className={styles.list}>
        {changelog.map((entry) => (
          <li key={`${entry.date}-${entry.title.en}`} className={styles.entry}>
            <div className={styles.meta}>
              <time dateTime={entry.date}>{entry.date}</time>
              {entry.version ? (
                <span className={styles.version}>
                  {t.versionLabel} {entry.version}
                </span>
              ) : entry.area === 'web' ? null : (
                <span className={styles.unreleased}>{t.unreleased}</span>
              )}
              {entry.area ? (
                <span className={styles.area}>{entry.area === 'web' ? t.areaWeb : t.areaApp}</span>
              ) : null}
            </div>
            <h2 className={styles.entryTitle}>{entry.title[lang]}</h2>
            <p className={styles.description}>{entry.description[lang]}</p>
          </li>
        ))}
      </ol>
    </article>
  )
}
